import Vue from "vue";
import isNil from "lodash/isNil";
// import formDatas from '../../lib/formDatas'
// import router from '../../router'

export default {
  state: {
    local: "ko", // ko 기본 , en 영어
  },
  getters: {
    // isUser: state => Boolean(state.user.user_no),
    local: (state) => state.local,
  },
  mutations: {
    setLocal(state, payload) {
      state.local = payload;
    },
  },
  actions: {
    toggleLocal({ commit }, payload) {
      commit("setLocal", payload);
    },
  },
};
